import { PureComponent } from 'react'
import { ScrollLink } from 'react-scroll'
import styles from './ScrollAnchorLink.css'
import classNames from 'classnames'

@ScrollLink
class ScrollAnchorLink extends PureComponent {
  render () {
    const {
      className,
      id,
      ...restProps
    } = this.props

    const fullClassName = classNames(
      styles.anchorLink,
      { [className]: !!className }
    )

    const uid = `${id}-link`

    return (
      <li
        {...restProps}
        className={fullClassName}
        id={uid}
        data-role={uid}
      >
        <a>
          {this.props.children}
        </a>
      </li>
    )
  }
}

export default ScrollAnchorLink
